import { EducationalLevel, Region } from '@/types/contest'

export function mapEducationLevelLabel(educationLevel: EducationalLevel) {
  switch (educationLevel) {
    case 'PHD':
      return 'ระดับปริญญาเอก'
    case 'MASTER':
      return 'ระดับปริญญาโท'
    case 'BACHELOR':
      return 'ระดับปริญญาตรี'
    case 'HIGH':
      return 'ระดับมัธยมปลาย'
    case 'PRIMARY':
      return 'ระดับประถมศึกษา'
    case 'ANY':
      return 'ทุกระดับ'
    case 'MIDDLE':
      return 'ระดับมัธยมต้น'
    default:
      return ''
  }
}

export function mapRegionLabel(region: Region) {
  switch (region) {
    case 'BANGKOK_METROPOLITAN':
      return 'กรุงเทพมหานครและปริมณฑล'
    case 'NORTHERN':
      return 'ภาคเหนือ'
    case 'NORTH_EASTERN':
      return 'ภาคตะวันออกเฉียงเหนือ'
    case 'EASTERN':
      return 'ภาคตะวันออก'
    case 'WESTERN':
      return 'ภาคตะวันตก'
    case 'SOUTHERN':
      return 'ภาคใต้'
    case 'CENTRAL':
      return 'ภาคกลาง'
    default:
      return ''
  }
}
